import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';

export interface IAccountSignupVerifyTxData {
    accountEmail: string;
    activationCode: string;
}

export class APIAccountSignupVerifyManager extends APIBaseManager<void, void, IAccountSignupVerifyTxData, void> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_AccountSignupVerify';
        this._apiMethod = 'POST';
    }

    protected getRequestURL(): string {
        return super.getRequestURL() + 'accounts/emailVerify';
    }
}